import hasSystemTag from '@/common/utils/model.util';

export type StoreProjectModel = {
  id: string,
  name: string,
  description: string,
  isEnabled: boolean,
  domainId: string,
  membersCount: number,
  tags: string[],
  isSystem: boolean,
  quotas: undefined
} & Partial<DomainProject>;

function domainProject(attributes: DomainProject): Nullable<StoreProjectModel> {
  if (!attributes) {
    return null;
  }

  const {
    id,
    name,
    description,
    enabled: isEnabled,
    domain_id: domainId,
    members_count: membersCount,
    tags,
    created_at
  } = attributes;

  return {
    id,
    name,
    description,
    isEnabled,
    domainId,
    membersCount,
    tags,
    isSystem: hasSystemTag(tags),
    created_at,
    quotas: undefined
  };
}

export default domainProject;
